import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Building2, ChevronsUpDown, Check, UserCheck } from "lucide-react";

export const PLANTA_TEXTO = "HUMAN RESOURCES MANAGMENT SA (PLANTA)";
let cache = null;
const sinTildes = (s) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
const filtro = (value, search) => (sinTildes(value).includes(sinTildes(search.trim())) ? 1 : 0);

export function invalidarEmpresas() { cache = null; }

export function useEmpresasUsuarias() {
  const [lista, setLista] = useState(cache || []);
  useEffect(() => {
    api.get("/empresas-usuarias").then((r) => { cache = r.data; setLista(r.data); }).catch(() => setLista([]));
  }, []);
  return lista;
}

export function EmpresaUsuariaSelect({ value, onChange, permitirPlanta = true, testid = "empresa-usuaria-select", className = "" }) {
  const lista = useEmpresasUsuarias();
  const [open, setOpen] = useState(false);
  const elegir = (v) => { onChange(v); setOpen(false); };
  const enCatalogo = !value || value === PLANTA_TEXTO || lista.some((e) => e.nombre === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} className={`flex w-full items-center justify-between gap-2 rounded-lg border bg-white px-3 py-2 text-left text-sm outline-none focus:border-vino-500 ${enCatalogo ? "border-slate-200" : "border-amber-300 bg-amber-50"} ${className}`}>
          <span className={`truncate ${value ? "text-slate-800" : "text-slate-400"}`}>{value === PLANTA_TEXTO ? "Trabajador de planta (Human)" : value || "Selecciona la empresa usuaria"}{!enCatalogo && " · no identificada"}</span>
          <ChevronsUpDown className="h-4 w-4 shrink-0 text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] min-w-[260px] p-0" align="start">
        <Command filter={filtro}>
          <CommandInput placeholder="Buscar empresa…" data-testid={`${testid}-buscar`} />
          <CommandList>
            <CommandEmpty>No está en el catálogo. Solo un administrador puede registrarla en Configuración.</CommandEmpty>
            {permitirPlanta && (
              <CommandGroup heading="Empleador">
                <CommandItem value="trabajador de planta human" onSelect={() => elegir(PLANTA_TEXTO)} data-testid={`${testid}-planta`}>
                  <UserCheck className="mr-2 h-4 w-4 text-vino-700" /> Trabajador de planta (Human)
                  {value === PLANTA_TEXTO && <Check className="ml-auto h-4 w-4" />}
                </CommandItem>
              </CommandGroup>
            )}
            <CommandGroup heading="Empresas usuarias">
              {lista.map((e) => (
                <CommandItem key={e.id} value={e.nombre} onSelect={() => elegir(e.nombre)} data-testid={`${testid}-op-${e.id}`}>
                  <Building2 className="mr-2 h-4 w-4 text-slate-400" /> {e.nombre}
                  {value === e.nombre && <Check className="ml-auto h-4 w-4" />}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}

export function EmpresaBadge({ r }) {
  if (r.tipo_trabajador === "planta") return <span className="rounded-full bg-vino-50 px-2 py-0.5 text-xs font-semibold text-vino-700" data-testid={`empresa-planta-${r.id}`}>Trabajador de planta</span>;
  if (r.empresa_estado === "no_identificada") return <span className="text-slate-600">{r.empresa_cliente} <span className="ml-1 rounded-full bg-amber-50 px-2 py-0.5 text-[11px] font-semibold text-amber-800" data-testid={`empresa-noid-${r.id}`}>No identificada</span></span>;
  return <span className="text-slate-600">{r.empresa_cliente}</span>;
}
